import { isMobile } from "react-device-detect";
import { useRecoilState } from "recoil";
import { kakaoModalState } from "src/atoms/KakaoModalAtom";

export const useKakaoModal = () => {
  const goToKakaoChannel = () => {
    const url = isMobile
      ? "https://pf.kakao.com/_xbDexfG/chat"
      : "https://pf.kakao.com/_xbDexfG";
    window.open(url, "_blank");
  };

  const [showKakaoModal, setShowKakaoModal] = useRecoilState(kakaoModalState);
  const onClickHandler = () => {
    if (isMobile) {
      goToKakaoChannel();
    } else {
      setShowKakaoModal((prev) => !prev);
    }
  };
  return {
    showKakaoModal,
    setShowKakaoModal,
    onClickHandler,
  };
};
